export enum LogLevel {
    Info = 4,
    Debug = 3,
    Warn = 2,
    Error = 1
}

export const logLevelValuesMap = {
    4: LogLevel.Info,
    3: LogLevel.Debug,
    2: LogLevel.Warn,
    1: LogLevel.Error
};
